import PageHeader from "app/shared/PageHeader";
import "../../FinkAnalytics.scss";
import {
  Button,
  Checkbox,
  Input,
  message,
  Modal,
  Popconfirm,
  Select,
  Switch,
  Tag,
} from "antd";
import { useEffect, useRef, useState } from "react";
import { AgTableClient } from "app/shared/AgTable";
import { PlusOutlined, SaveOutlined } from "@ant-design/icons";
import { apiGet, apiPost } from "app/services/apiServices";
import {
  API_ENDPOINT_FETCH_COLUMN_MAPPING_FOR_DESTINATION,
  API_ENDPOINT_FETCH_DB_TABLE_PREVIEW,
  API_ENDPOINT_FETCH_DB_TABLE_PREVIEW_PG,
  API_ENDPOINT_FETCH_S3_FILE_DATA,
  API_ENDPOINT_ZA_TABLE_CREATE_SCHEMA,
  API_ENDPOINT_ZA_TABLE_GET_SCHEMA_DETAILS,
  API_ENDPOINT_ZA_TABLE_GET_TABLE_DATA_REF,
  API_ENDPOINT_ZA_TABLE_UPDATE_SCHEMA,
} from "../../finkanalytics.constants";
import Loader from "app/shared/Loader";

import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { processZARowForColumnDefs } from "../../fa.helper";
import { includes } from "lodash";
import { Label } from "@mui/icons-material";

const dataTypeColor: any = {
  STRING: "#2980b9",
  NUMBER: "#27ae60",
  DATE: "#34495e",
};

const UI_FORMAT_TYPES: any = [
  { value: "FALSE", label: "None" },
  { value: "CHIP", label: "Chip" },
  { value: "CHIP_SHORT_TEXT", label: "Chip with Sort Text" },
  { value: "RATE", label: "Rate %" },
  { value: "ENTITY", label: "Entity" },
  { value: "ENTITY_WITH_LOGO", label: "Entity with Logo" },
  { value: "COUNTRY", label: "Country" },
  { value: "CURRENCY", label: "Currency" },

  { value: "AIRLINE", label: "Airline" },
  { value: "INVOICE", label: "INVOICE" },

  { value: "PERSON", label: "Person" },
  { value: "NUMBER", label: "Number" },
  { value: "PARTNERSHIP", Label: "Partnership" },
  { value: "AMOUNT", label: "Amount" },
  { value: "AMOUNT_BOLD", label: "Amount In Bold" },
  { value: "GSTIN_STATE", label: "GSTIN State" },
  { value: "DATE", label: "Date" },
  { value: "TAGS", label: "Tags" },
  { value: "ROUTE", label: "Route " },
  { value: "MATCH", label: "Match" },
  { value: "MATCH_COMPARE", label: "Match Compare" },
  { value: "MATCH_PRESENCE", label: "Check Key Existence " },
  { value: "MATCH_COMPARE_TEXT", label: "Compare Text" },
];

const VALIDATION_TYPES: any = [
  { value: "GSTIN", label: "GSTIN" },
  { value: "EMAIL", label: "Email" },
  { value: "PNR", label: "PNR" },
  { value: "PAN", label: "PAN" },
];

export default function FASetup(props: any) {
  const [showModal, setShowModal] = useState(false);
  const [tableData, setTableData] = useState<any[]>([]);
  const [isLoading, setLoading] = useState(false);
  const [rowData, setRowData] = useState<any[]>([]);
  const { schemaId } = useParams(); // Extract the id from the URL
  const [configData, setConfigData] = useState("");
  const [selectedCol, setSelectedCol] = useState<any>(null);
  const [schemaInfo, setSchemaInfo] = useState<any>(null);
  const gridRef: any = useRef();
  const [schemaName, setSchemaName] = useState(
    "schema_" + Math.floor(1000 + Math.random() * 9000),
  );
  const [columnMapList, setColumnMapList] = useState([]);
  const [moduleId, setModuleId] = useState("CRM");
  const [messageApi, contextHolder] = message.useMessage();
  const location = useLocation();
  const {
    dbType,
    database,
    table,
    sourceType,
    zaId,
    zaViewId,
    reportType,
    reportClientType,
    tmcDomain,
    workspaceId,
    workspaceSelection,
  } = location.state || {};
  const [searchParams] = useSearchParams();
  const onlyColumnMapping = location?.pathname.includes("columnmap");
  const S3_OBJECT_FILE_NAME = location.state?.filename;
  const { dataset, frequency } = location?.state || {};
  useEffect(() => {
    fetchMappingColumns();
    if (schemaId) {
      fetchEditDetails();
    } else if (onlyColumnMapping) {
      fetchPreviewDataForS3Object();
    } else {
      fetchGeneratableDataForSchmea();
    }
  }, []);

  const fetchMappingColumns = async () => {
    const response = await apiPost(
      API_ENDPOINT_FETCH_COLUMN_MAPPING_FOR_DESTINATION,
    );
    if (response.status) {
      let processColumns: any = [];
      (response.data || []).forEach((element: any) => {
        processColumns.push({
          label: element.column_name,
          value: element.column_name,
          dataType: element.data_type,
          is_nullable: element.is_nullable,
        });
      });
      setColumnMapList(processColumns);
    }
  };

  const fetchGeneratableDataForSchmea = () => {
    if (onlyColumnMapping) return;
    if (sourceType === "zohoanalytics") {
      fetchZATableData();
    } else {
      fetchInternalDBDataForSchema();
    }
  };

  const fetchPreviewDataForS3Object = async () => {
    setLoading(true);

    const response = await apiPost(API_ENDPOINT_FETCH_S3_FILE_DATA, {
      filename: S3_OBJECT_FILE_NAME,
    });

    setTableData(response.data);
    const processed = processZARowForColumnDefs(response.data, false, true);
    setRowData(processed);
    setLoading(false);
  };

  const fetchInternalDBDataForSchema = async () => {
    setLoading(true);
    const payload = {
      startRow: 0,
      endRow: 100,
      rowGroupCols: [],
      valueCols: [],
      pivotCols: [],
      pivotMode: false,
      groupKeys: [],
      filterModel: {},
      sortModel: [],
      database: database,
      dbType: dbType,
      table: table,
    };
    const response = await apiPost(
      dbType === "postgre"
        ? API_ENDPOINT_FETCH_DB_TABLE_PREVIEW_PG
        : API_ENDPOINT_FETCH_DB_TABLE_PREVIEW,
      payload,
    );

    setTableData(response.data.rows);
    const processed = processZARowForColumnDefs(response.data.rows, false);
    setRowData(processed);
    setLoading(false);
  };

  const fetchEditDetails = async () => {
    setLoading(true);
    const response = await apiGet(
      `${API_ENDPOINT_ZA_TABLE_GET_SCHEMA_DETAILS}/${schemaId}`,
    );
    setSchemaInfo(response.data);
    setSchemaName(response.data.name);
    setModuleId(response.data.moduleId);

    // Debug: Log the full response structure
    console.log("Full response.data:", response.data);
    console.log("Schema state structure:", response.data?.state);
    console.log("Is state array?", Array.isArray(response.data?.state));

    // Check if there's a rawState or originalState field
    if (response.data?.rawState) {
      console.log("Found rawState:", response.data.rawState);
    }
    if (response.data?.originalState) {
      console.log("Found originalState:", response.data.originalState);
    }

    // Check columnMapping structure
    if (Array.isArray(response.data?.state?.columnMapping)) {
      console.log(
        "columnMapping sample:",
        response.data.state.columnMapping[0],
      );
      console.log(
        "columnMapping has column_type?",
        response.data.state.columnMapping[0]?.column_type,
      );
    }

    processMongoDefination(response.data?.state);
  };

  const agFilterTypeMap: any = {
    agTextColumnFilter: "STRING",
    agNumberColumnFilter: "NUMBER",
    agDateColumnFilter: "DATE",
  };
  const processMongoDefination = (CoulmnConfigData: any) => {
    console.log("processMongoDefination called with:", CoulmnConfigData);
    console.log("columnMapping:", CoulmnConfigData.columnMapping);

    // Check if state is directly an array (from saved payload)
    if (Array.isArray(CoulmnConfigData)) {
      console.log("State is an array, processing directly");
      // Ensure all rows have column_type field (even if undefined)
      const processedData = CoulmnConfigData.map((row: any) => {
        const processedRow = {
          ...row,
          column_type: row.column_type || undefined,
        };
        console.log(
          `Row ${row.destination_key} column_type:`,
          processedRow.column_type,
        );
        return processedRow;
      });
      console.log("Processed data:", processedData);
      setRowData(processedData);
      setLoading(false);
      return;
    }

    // Create a map from columnMapping to preserve column_type and other fields
    let columnMappingMap: any = {};
    if (Array.isArray(CoulmnConfigData.columnMapping)) {
      console.log("Creating map from columnMapping");
      CoulmnConfigData.columnMapping.forEach((item: any) => {
        if (item.destination_key) {
          columnMappingMap[item.destination_key] = item;
          console.log(`Mapping ${item.destination_key}:`, item);
        }
      });
    }

    // Otherwise, process from columnDefs format
    let mainColDefs: any = [];
    let columnArray = CoulmnConfigData.columnDefs;
    columnArray.forEach((element: any, mainIndex: any) => {
      if (element.children && element.children.length > 0) {
        element.children.forEach((childElement: any, index: any) => {
          let getSourceKey = (CoulmnConfigData.columnMapping || []).find(
            (item: any) => item.destination_key === childElement.field,
          );
          // Get column_type from columnMapping if available
          const columnMappingItem = columnMappingMap[childElement.field];
          console.log(
            `Getting column_type for ${childElement.field}:`,
            columnMappingItem?.column_type,
          );
          mainColDefs.push({
            id: `column_${mainIndex}_${index}`,
            source_key: getSourceKey?.source_key || childElement.field,
            destination_key: childElement.field,
            data_type: agFilterTypeMap[childElement.filter] || "STRING",
            header_name: childElement.headerName,
            ui_format_type: childElement.formatType || "NONE",
            enable_aggregation: childElement.enableValue,
            enable_row_group: childElement.enableRowGroup,
            enable_column_pivot: childElement.enablePivot,
            filter_type: childElement.filter,
            hide_column: childElement.hide,
            default_grouping: childElement.rowGroup,
            default_pinning: childElement.pinned || "NONE",
            column_group_show: childElement.columnGroupShow || "NONE",
            default_sorting: childElement.sort || "NONE",
            column_grouping: element.headerName,
            match_config_json: JSON.stringify(childElement.formatProps || {}),
            column_type:
              columnMappingItem?.column_type ||
              childElement.column_type ||
              undefined,
            // match_config_json: "",
          });
        });
      } else {
        let findSourceKey = (CoulmnConfigData.columnMapping || []).find(
          (item: any) => item.destination_key === element.field,
        );
        // Get column_type from columnMapping if available
        const columnMappingItem = columnMappingMap[element.field];
        console.log(
          `Getting column_type for ${element.field}:`,
          columnMappingItem?.column_type,
        );
        mainColDefs.push({
          id: "column_main_" + mainIndex,
          source_key: findSourceKey?.source_key || element.field,
          destination_key: element.field,
          data_type: agFilterTypeMap[element.filter] || "STRING",
          header_name: element.headerName,
          ui_format_type: element.formatType || "NONE",
          enable_aggregation: element.enableValue,
          enable_row_group: element.enableRowGroup,
          enable_column_pivot: element.enablePivot,
          filter_type: element.filter,
          hide_column: element.hide,
          default_grouping: element.rowGroup,
          default_pinning: element.pinned || "NONE",
          column_group_show: element.columnGroupShow || "NONE",
          default_sorting: element.sort || "NONE",
          match_config_json: JSON.stringify(element.formatProps || {}),
          column_type:
            columnMappingItem?.column_type || element.column_type || undefined,
        });
      }
    });
    setRowData(mainColDefs);
    setLoading(false);
  };

  const dataTypeMap: any = {
    "character varying": "STRING",
    date: "DATE",
    numeric: "NUMBER",
  };

  const fetchZATableData = async () => {
    setLoading(true);
    const response = await apiPost(API_ENDPOINT_ZA_TABLE_GET_TABLE_DATA_REF, {
      tableId: zaId,
      tableName: zaId,
    });
    setTableData(response);
    const processed = processZARowForColumnDefs(response, true);
    setRowData(processed);
    setLoading(false);
  };

  const handleUpdateSchemaMeta = (
    columnData: any,
    changeInfo: any,
    columnId: any,
    dataTypeCheck = false,
    fullObjectValue: any = null,
  ) => {
    console.log("data and value", fullObjectValue, columnData);

    if (dataTypeCheck) {
      if (columnData.data_type !== dataTypeMap[fullObjectValue.dataType]) {
        messageApi.open({
          type: "error",
          content: "Data Type does not match use appropriate value",
        });
        return;
      }
    }
    // Create a copy of the row to be updated
    if (columnData[columnId] === changeInfo) {
      return; // If no change, exit early
    }
    const updatedRow = {
      ...columnData,
      [columnId]: changeInfo,
    };

    // Apply the update transaction
    gridRef.current &&
      gridRef.current.applyTransaction({ update: [updatedRow] });
  };

  const handleDeleteRow = (rowId: string) => {
    gridRef.current &&
      gridRef.current.applyTransaction({ remove: [{ id: rowId }] });
  };

  const processForDuplicateRows = (arrayData: any) => {
    const seen = new Set();
    return arrayData.filter((item: any) => {
      const keyValue = item["source_key"];
      if (seen.has(keyValue)) {
        return false;
      } else {
        seen.add(keyValue);
        return true;
      }
    });
  };

  const columnDefs = [
    {
      field: "source_key",
      headerName: "Source Key",
      width: 300,
      suppressMenu: true,
      rowDrag: true,
      editable: true,
    },
    {
      field: "destination_key",
      headerName: "Destination Key",
      width: 240,
      suppressMenu: true,
      editable: true,
    },
    {
      field: "data_type",
      headerName: "Data Type",
      suppressMenu: true,
      width: 120,
      editable: true,
      cellEditor: "agSelectCellEditor", // Use built-in dropdown
      cellEditorParams: {
        values: ["NUMBER", "STRING", "DATE"], // Dropdown options
      },
    },
    {
      field: "column_type",
      headerName: "Column Type",
      suppressMenu: true,
      width: 120,
      editable: true,
      cellEditor: "agSelectCellEditor", // Use built-in dropdown
      cellEditorParams: {
        values: ["INVOICE_NUMBER"], // Dropdown options
      },
      valueGetter: (params: any) => {
        return params.data?.column_type || undefined;
      },
      valueSetter: (params: any) => {
        if (params.data) {
          params.data.column_type = params.newValue;
          return true;
        }
        return false;
      },
    },
    {
      field: "header_name",
      headerName: "Header Name",
      suppressMenu: true,
      width: 250,
      editable: true,
    },
    {
      field: "ui_format_type",
      headerName: "UI Format Type",
      suppressMenu: true,
      width: 250,
      editable: true,
      cellEditor: "agSelectCellEditor", // Use built-in dropdown
      cellEditorParams: {
        values: [
          "FALSE",
          "CHIP",
          "CHIP_SHORT_TEXT",
          "RATE",
          "ENTITY",
          "ENTITY_WITH_LOGO",
          "COUNTRY",
          "CURRENCY",
          "AIRLINE",
          "INVOICE",
          "PERSON",
          "NUMBER",
          "PARTNERSHIP",
          "AMOUNT",
          "AMOUNT_BOLD",
          "GSTIN_STATE",
          "DATE",
          "TAGS",
          "ROUTE",
          "MATCH",
          "MATCH_COMPARE",
          "MATCH_PRESENCE",
          "MATCH_COMPARE_TEXT",
          "ZA_BOOLEAN_SIGN",
        ], // Dropdown options
      },
    },
    {
      field: "match_config_json",
      headerName: "UI Format Config",
      suppressMenu: true,
      width: 250,
      editable: true,
    },
    {
      field: "column_grouping",
      headerName: "Column Grouping",
      suppressMenu: true,
      width: 200,
      editable: true,
    },
    {
      field: "enable_row_group",
      headerName: "Row Groping",
      width: 140,
      editable: true,
      cellRendererFramework: (params: any) => (
        <label className="switch">
          <input
            type="checkbox"
            checked={params.value}
            onChange={() => {
              params.setValue(!params.value); // Toggle the value
            }}
          />
          <span className="slider"></span>
        </label>
      ),
    },

    {
      field: "enable_aggregation",
      headerName: "Aggregation",
      width: 140,
      editable: true,
      cellRendererFramework: (params: any) => (
        <label className="switch">
          <input
            type="checkbox"
            checked={params.value}
            onChange={() => {
              params.setValue(!params.value); // Toggle the value
            }}
          />
          <span className="slider"></span>
        </label>
      ),
    },
    {
      field: "enable_column_pivot",
      headerName: "Column Pivot",
      suppressMenu: true,
      width: 140,
      editable: true,
      cellRendererFramework: (params: any) => (
        <label className="switch">
          <input
            type="checkbox"
            checked={params.value}
            onChange={() => {
              params.setValue(!params.value); // Toggle the value
            }}
          />
          <span className="slider"></span>
        </label>
      ),
    },
    {
      field: "hide_column",
      headerName: "Hide Column",
      suppressMenu: true,
      width: 140,
      editable: true,
      cellEditor: "agSelectCellEditor", // Use built-in dropdown
      cellEditorParams: {
        values: ["All", "CORPORATE"], // Dropdown options
      },
    },
    {
      field: "default_grouping",
      headerName: "Default Grouping",
      suppressMenu: true,
      width: 140,
      editable: true,
      cellRendererFramework: (params: any) => (
        <label className="switch">
          <input
            type="checkbox"
            checked={params.value}
            onChange={() => {
              params.setValue(!params.value); // Toggle the value
            }}
          />
          <span className="slider"></span>
        </label>
      ),
    },
    {
      field: "default_sorting",
      headerName: "Default Sorting",
      suppressMenu: true,
      width: 140,
      editable: true,
      cellEditor: "agSelectCellEditor", // Use built-in dropdown
      cellEditorParams: {
        values: ["FALSE", "ASC", "DESC"], // Dropdown options
      },
    },
    {
      field: "default_pinning",
      headerName: "Default Pinning",
      suppressMenu: true,
      width: 140,

      editable: true,
      cellEditor: "agSelectCellEditor", // Use built-in dropdown
      cellEditorParams: {
        values: ["FALSE", "LEFT", "RIGHT"], // Dropdown options
      },
    },
    {
      field: "column_group_show",
      headerName: "Column Group Show",
      suppressMenu: true,
      width: 140,
      editable: true,
      cellEditor: "agSelectCellEditor", // Use built-in dropdown
      cellEditorParams: {
        values: ["FALSE", "open", `["open","close"]`], // Dropdown options
      },
    },

    {
      field: "action",
      headerName: "Action",
      suppressMenu: true,
      width: 140,
      cellRenderer: (params: any) => (
        <Button
          size="small"
          danger
          onClick={() => handleDeleteRow(params?.data?.id)}
        >
          DELETE
        </Button>
      ),
    },
  ];

  const ColumnMappingDefs = [
    {
      field: "source_key",
      headerName: "Source Key",
      width: 300,
      suppressMenu: true,
      rowDrag: true,
      cellRenderer: (params: any) => (
        <Input
          placeholder="Source Key"
          size="small"
          id={params?.data?.source_key}
          defaultValue={params?.data?.source_key}
          style={{
            fontSize: 11,

            width: 250,
          }}
          onPressEnter={(e: any) =>
            handleUpdateSchemaMeta(params.data, e.target.value, "source_key")
          }
          onBlur={(e: any) =>
            handleUpdateSchemaMeta(params.data, e.target.value, "source_key")
          }
        />
      ),
    },
    {
      field: "destination_key",
      headerName: "Destination Key",
      width: 240,
      suppressMenu: true,
      cellRenderer: (params: any) =>
        onlyColumnMapping ? (
          <Select
            defaultValue={params?.data?.destination_key}
            style={{ width: "100%" }}
            size="small"
            onChange={(selectedValue: any, fullObjectValue: any) => {
              console.log("fullObjectValue:", fullObjectValue);
              handleUpdateSchemaMeta(
                params.data,
                selectedValue,
                "destination_key",
                true,
                fullObjectValue,
              );
            }}
            options={columnMapList}
          />
        ) : (
          <Input
            placeholder="Destination Key"
            size="small"
            id={params?.data?.destination_key}
            defaultValue={params?.data?.destination_key}
            style={{ fontSize: 11 }}
            onPressEnter={(e: any) =>
              handleUpdateSchemaMeta(
                params.data,
                e.target.value,
                "destination_key",
              )
            }
            onBlur={(e: any) =>
              handleUpdateSchemaMeta(
                params.data,
                e.target.value,
                "destination_key",
              )
            }
          />
        ),
    },
    {
      field: "data_type",
      headerName: "Data Type",
      suppressMenu: true,
      width: 120,
      cellRenderer: (params: any) => (
        <Select
          defaultValue={params?.data?.data_type}
          style={{ width: "100%" }}
          size="small"
          onChange={(selectedValue: any) => {
            handleUpdateSchemaMeta(params.data, selectedValue, "data_type");
          }}
          options={[
            { value: "NUMBER", label: "Number" },
            { value: "STRING", label: "Text" },
            { value: "DATE", label: "Date" },
          ]}
        />
      ),
    },
    {
      field: "validation_type",
      headerName: "Validation Type",
      suppressMenu: true,
      width: 250,
      cellRenderer: (params: any) => (
        <Select
          defaultValue={params?.data?.validation_type}
          style={{ width: "100%" }}
          size="small"
          options={VALIDATION_TYPES}
          onChange={(selectedValue: any) =>
            handleUpdateSchemaMeta(
              params.data,
              selectedValue,
              "validation_type",
            )
          }
        />
      ),
    },
    {
      field: "is_required",
      headerName: "Is Required",
      suppressMenu: true,
      width: 250,
      cellRenderer: (params: any) => (
        <Switch
          checked={params?.data?.is_required}
          size="small"
          onChange={() =>
            handleUpdateSchemaMeta(
              params.data,
              !params.data?.is_required,
              "is_required",
            )
          }
        />
      ),
    },
  ];

  const getRequiredCriteriaMatched = (payloadData: any) => {
    let requiredFields = columnMapList.filter(
      (item: any) => item.is_nullable === "NO",
    );

    let finalColumnRequired = (requiredFields || []).map(
      (item: any) => item.value,
    );

    let result: any = [];

    finalColumnRequired.forEach((field: any) => {
      const item = payloadData.find(
        (entry: any) => entry.destination_key === field,
      );
      if (!item) {
        result.push(field);
      }
    });

    return result;

    // let totalRequiredFieldsUsed = payloadData.filter((item:any)=>item.);
  };
  const handleSaveSchema = async () => {
    const payloadData =
      gridRef.current && gridRef.current.getFinalDataFromTable();

    if (onlyColumnMapping) {
      const extractedData = getRequiredCriteriaMatched(payloadData);
      if (extractedData.length > 0) {
        messageApi.open({
          type: "error",
          content: `Required Fields need to be mapped ${JSON.stringify(
            extractedData,
          )}`,
        });
        return;
      }
    }
    const tableLastNameSplit = moduleId.split("_");
    const tableLastName = tableLastNameSplit[tableLastNameSplit.length - 1];

    const tableName =
      reportType === "AIRLINE"
        ? `airline_recon_${tableLastName.toLocaleLowerCase()}`
        : `hotel_recon_${tableLastName.toLocaleLowerCase()}`;

    // handleDownload();
    const payload = {
      state: payloadData,
      name: schemaName,
      moduleId: moduleId,
      schemaId: schemaInfo?.id,
      column_mapping: sourceType === "zohoanalytics" ? true : false,
      dbType: dbType || "postgre",
      database: database || "gstservice_db",
      table: table || tableName,
      frequency: frequency,
      dataset: dataset,
      onlyColumnMapping: onlyColumnMapping,
      za_table_name: zaId,
      zohoViewId: zaViewId,
      pg_table_name: table || tableName,
      reportClientType: reportClientType,
      tmcDomain: tmcDomain,
      workspaceId: workspaceId,
      reportType: reportType,
      workspaceSelection: workspaceSelection,
    };

    const response = await apiPost(
      API_ENDPOINT_ZA_TABLE_CREATE_SCHEMA,
      payload,
    );
    if (response.status) {
      messageApi.open({
        type: "success",
        content: "Awesome! your schema has been saved",
      });
    } else {
      messageApi.open({
        type: "error",
        content: response.message || "Could not save schema",
      });
    }
  };
  const handleUpdateSchema = async () => {
    const payloadData =
      gridRef.current && gridRef.current.getFinalDataFromTable();
    // handleDownload();
    const payload = {
      state: payloadData,
      name: schemaName,
      moduleId: moduleId,
      schemaId: schemaId,
      column_mapping: sourceType === "zohoanalytics" ? true : false,
      reportClientType: reportClientType,
      tmcDomain: tmcDomain,
      workspaceId: workspaceId,
      reportType: reportType,
      workspaceSelection: workspaceSelection,
    };

    const response = await apiPost(
      API_ENDPOINT_ZA_TABLE_UPDATE_SCHEMA,
      payload,
    );
    if (response.status) {
      messageApi.open({
        type: "success",
        content: "Awesome! your schema has been saved",
      });
    } else {
      messageApi.open({
        type: "error",
        content: "Could not save schema",
      });
    }
  };

  const handleAddNewRow = () => {
    let newRowObj = {
      id: `column_${Math.floor(1000 + Math.random() * 9000)}_${Math.floor(
        1000 + Math.random() * 9000,
      )}`,
      source_key: "source_key",
      destination_key: "destination_key",
      data_type: "STRING",
      header_name: "New Header",
      ui_format_type: "FALSE",
      enable_aggregation: false,
      enable_row_group: true,
      enable_column_pivot: false,
      filter_type: "agTextColumnFilter",
      hide_column: false,
      default_grouping: false,
      default_pinning: "FALSE",
      column_group_show: false,
      default_sorting: "FALSE",
      column_grouping: "",
      match_config_json: "{}",
      column_type: undefined,
    };
    // setRowData([newRowObj, ...rowData]);
    gridRef.current && gridRef.current.applyTransaction({ add: [newRowObj] });
  };
  return (
    <div className="FASetup">
      <div className="Header">
        <PageHeader
          leftActions={
            <>
              <Input
                size="small"
                placeholder="Schema Name"
                style={{ width: 220, marginRight: 12 }}
                value={schemaName}
                onChange={(e: any) => setSchemaName(e.target.value)}
              />
              <Input
                size="small"
                placeholder="Module ID (eg: AIRLINE_RECON)"
                style={{ width: 220 }}
                value={moduleId}
                onChange={(e: any) => setModuleId(e.target.value)}
              />
            </>
          }
          goBack
          rightActions={
            <div style={{ display: "flex", alignItems: "center" }}>
              <Popconfirm
                placement="topLeft"
                title={"Saving Schema"}
                description={"Are you sure want to save this"}
                okText="Yes"
                cancelText="No"
                onConfirm={
                  props.editMode ? handleUpdateSchema : handleSaveSchema
                }
              >
                <Button
                  size="small"
                  type="primary"
                  icon={<SaveOutlined />}
                  // onClick={handleSaveSchema}
                >
                  Save Schema
                </Button>
              </Popconfirm>

              <Button
                size="small"
                type="primary"
                icon={<PlusOutlined />}
                style={{ marginLeft: 24 }}
                onClick={handleAddNewRow}
              >
                Add New Row
              </Button>
            </div>
          }
        />
      </div>
      {/* <div className="SearchBoxContainer">
        <SearchTable
          placeholder="Search ZA Table"
          style={{ width: 400, height: 40 }}
          onChange={handleSearch}

        />
      </div> */}
      <div style={{ height: "100%", width: "100%" }}>
        {isLoading ? (
          <Loader />
        ) : (
          <AgTableClient
            // @ts-ignore
            rowData={processForDuplicateRows(rowData)}
            columnDefs={onlyColumnMapping ? ColumnMappingDefs : columnDefs}
            hideToolbar
            updateNewData={(data: any) => setRowData(data)}
            enableDragging
            dragColumn="source_key"
            showStatusBar
            ref={gridRef}
            disableLazy
            rowIdKey={"id"}
            useRowId
            enableDirectEdit
            rowSelection="multiple"
          />
        )}
      </div>

      <Modal
        title="UI Format Configuration"
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={false}
      >
        <div>
          <Input
            defaultValue={configData}
            onBlur={(e) =>
              handleUpdateSchemaMeta(
                selectedCol,
                e.target.value,
                "match_config_json",
              )
            }
          />
          <Button
            size="small"
            style={{ marginTop: 24 }}
            type="primary"
            onClick={() => {
              setShowModal(false);
            }}
          >
            Save
          </Button>
        </div>
      </Modal>
      {contextHolder}
    </div>
  );
}
